import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center cache-box justify-space-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Search results are loaded from local database.", -1)
const _hoisted_3 = {
  key: 0,
  style: {"color":"#4bd63e"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "New songs have been played! Update database?", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "info"
}
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "d-flex align-center justify-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"white-space":"pre-wrap"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Multisearch:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " Each search filter might add more songs to the results "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Strict search:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " Each search filter will narrow down the results ")
], -1)
const _hoisted_11 = {
  class: "search-option-container d-flex align-center",
  style: {"gap":"10px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Changelog", -1)
const _hoisted_13 = { style: {"white-space":"pre-wrap"} }

import { ref, reactive, onMounted, computed } from "vue"
import { getSonglistHistory, getSongs } from "@/services/songlist"
import Card from "@/components/cards/Card.vue"
import Loader from "@/components/loaders/Loader.vue"
import Dialog from "@/components/dialogs/Dialog.vue"
import { SongResult, SearchOption, SongHistoryStore } from "@/types"
import changelog from "@/changelog.json"
import { cloneDeep } from "lodash"
import { useDisplay } from "vuetify"
import { songsDB } from "@/db/songsDB"


export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const { mobile } = useDisplay()
const historyJsonData = ref()
const songsJsonData = ref()
const results = ref<SongResult[]>([])
const resultsWithSearch = ref<SongResult[]>([])
const dataExists = ref(false)
const loading = ref(false)
const loadingSearch = ref(false)
const isKermanix = ref(false)
const openInfoDialog = ref(false)
const newSongsHasBeenPlayed = ref(false)
const channel = ref("")
const loadingText = ref("Loading data")
const totalPlayed = ref<number | undefined>()
const firstSong = ref<string | undefined>()
let playHistory: any
let allSongs: any
const songStoreLastUpdate = ref("")
const storedStreamers = ref<SongHistoryStore[]>([])

const searchOptions = ref<SearchOption[]>([
  {
    searchType: "Title",
    searchText: "",
  },
])

const textLabels = reactive({
  firstInput: "Channel name",
  searchText: "Search text",
})

const radioGroup = reactive({
  selectedSearch: "1",
  searchStyles: [
    { label: "Multisearch", value: "1" },
    { label: "Strict search", value: "2" },
  ],
})

const headers = [
  { title: "Title", value: "title", sortable: true },
  { title: "Artist", value: "artist", sortable: true },
  { title: "Requester", value: "requester", sortable: true },
  { title: "Date/Time(UTC)", value: "datetime", sortable: true },
]

const userInput = reactive({
  channel: "",
})

const resultsWithSearchFallback = computed(() => {
  return resultsWithSearch.value.length ? resultsWithSearch.value : []
})

const streamersFromStore = computed(() => {
  return storedStreamers.value.map((streamer) => streamer.channel) || []
})

function openInfo() {
  openInfoDialog.value = true
}

async function checkDBVersion(stored: SongHistoryStore | undefined) {
  try {
    if ((stored && stored.dbVersion !== changelog.versions[0].dbVersion) || stored && !stored.dbVersion) {
      await songsDB.streamers.delete(stored.channel)
      channel.value = stored.channel
      return true
    }
    return false
  } catch (error) {
    console.error("Error checking DB version: ", error)
  }
}

async function loadSonglistHistory(forceLoad: boolean) {
  try {
    loading.value = true
    newSongsHasBeenPlayed.value = false
    loadingText.value = "Loading songlist history"

    if (!userInput.channel) return

    const key = userInput.channel.toLowerCase()

    let stored = storedStreamers.value.find((streamer) => streamer.channel === key)

    // Reset stored value if DB version didn't match with changelog
    if (await checkDBVersion(stored)) {
      stored = undefined
    }

    if (stored && !forceLoad) {
      channel.value = stored.channel
      results.value = JSON.parse(JSON.stringify(stored.songs))
      resultsWithSearch.value = JSON.parse(JSON.stringify(stored.songs))
      songStoreLastUpdate.value = stored.lastUpdate
      totalPlayed.value = stored.totalPlayed
      firstSong.value = stored.firstSong
      allSongs = JSON.parse(JSON.stringify(stored.allSongs))
      newSongsHasBeenPlayed.value = stored.newSongsHasBeenPlayed
      dataExists.value = true
      loading.value = false

      // Check if new songs have been played since last update
      if (!newSongsHasBeenPlayed.value) {
        const response = await getSonglistHistory(
          userInput.channel.toLowerCase(),
          "0",
          "1"
        )
        if (response.data.total > stored.totalPlayed) {
          newSongsHasBeenPlayed.value = true
          await songsDB.streamers.put({
            lastUpdate: songStoreLastUpdate.value,
            channel: key,
            songs: JSON.parse(JSON.stringify(results.value)),
            firstSong: firstSong.value || "",
            totalPlayed: totalPlayed.value || 0,
            allSongs: allSongs || [],
            newSongsHasBeenPlayed: true,
            dbVersion: stored.dbVersion,
          })
        }
      }
      return
    }

    await loadSongs()

    results.value.length = 0
    playHistory = JSON.parse(JSON.stringify(historyJsonData.value))
    allSongs = JSON.parse(JSON.stringify(songsJsonData.value))
    firstSong.value =
      playHistory[playHistory.length - 1].createdAt

    resolveSongResults()

    songStoreLastUpdate.value = new Date().toISOString()

    if (forceLoad) {
      await songsDB.streamers.put({
        lastUpdate: songStoreLastUpdate.value,
        channel: key,
        songs: JSON.parse(JSON.stringify(results.value)),
        firstSong: firstSong.value || "",
        totalPlayed: totalPlayed.value || 0,
        allSongs: allSongs || [],
        newSongsHasBeenPlayed: false,
        dbVersion: changelog.versions[0].dbVersion as string,
      })
    } else {
      await songsDB.streamers.add({
        lastUpdate: songStoreLastUpdate.value,
        channel: key,
        songs: JSON.parse(JSON.stringify(results.value)),
        firstSong: firstSong.value || "",
        totalPlayed: totalPlayed.value || 0,
        allSongs: allSongs || [],
        newSongsHasBeenPlayed: false,
        dbVersion: changelog.versions[0].dbVersion as string,
      })
      loadStreamersFromDB()
    }
  } catch (error) {
    console.log("Error", error)
  } finally {
    loading.value = false
  }
}

async function loadSongs() {
  try {
    let responseData: any[] = []
    let page = 0
    const itemsPerPage = 3000
    let hasMoreData = true
    let totalSongs = 0

    // Loop to fetch all data in batches
    while(hasMoreData) {
      const response = await getSonglistHistory(
        userInput.channel.toLowerCase(),
        page.toString(),
        itemsPerPage.toString()
      )
      loadingText.value = `${responseData.length} / ${response.data.total} songs loaded`

      responseData.push(...response.data.items)

      page += 1

      if (response.data.items.length === 0) {
        historyJsonData.value = responseData
        totalSongs = response.data.total
        hasMoreData = false
      }
    }

    loadingText.value = "Loading unique song names"
    songsJsonData.value = await getSongs(userInput.channel.toLowerCase())
    totalPlayed.value = totalSongs
    channel.value = userInput.channel
  } catch (error) {
    console.log("Error", error)
  }
}

function updateSearch() {
  loadingSearch.value = true
  if (radioGroup.selectedSearch === "1") {
    multiSearch()
  } else {
    strictSearch()
  }
  loadingSearch.value = false
}

function resetSearch() {
  isKermanix.value = false
  searchOptions.value = [
    {
      searchType: "Title",
      searchText: "",
    },
  ]
  resultsWithSearch.value = results.value
}

function multiSearch() {
  let searchResults: SongResult[] = []
  const uniqueSongs = new Set<string>()
  isKermanix.value = false

  for (const option of searchOptions.value) {
    if (option.searchText === "") {
      continue
    }

    let filteredSongs: SongResult[] = []
    let clonedResults = cloneDeep(results.value)

    if (option.searchType === "Title") {
      filteredSongs = clonedResults.filter((item: SongResult) => {
        return item.title
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }
    if (option.searchType === "Artist") {
      filteredSongs = clonedResults.filter((item: SongResult) => {
        return item.artist
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }
    if (option.searchType === "Requester") {
      filteredSongs = clonedResults.filter((item: SongResult) => {
        return item.requester
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
      if (option.searchText.toLowerCase() === "kermanix") {
        isKermanix.value = true
      }
    }
    if (option.searchType === "Date/Time") {
      filteredSongs = clonedResults.filter((item: SongResult) => {
        return item.datetime
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }

    for (const song of filteredSongs) {
      if (!uniqueSongs.has(song.datetime)) {
        uniqueSongs.add(song.datetime)
        searchResults.push(song)
      }
    }
  }
  searchResults.sort((a, b) => b.datetime.localeCompare(a.datetime))
  resultsWithSearch.value = searchResults
}

function strictSearch() {
  let clonedResults = cloneDeep(results.value)

  for (const option of searchOptions.value) {
    if (option.searchText === "") {
      continue
    }

    if (option.searchType === "Title") {
      clonedResults = clonedResults.filter((item: SongResult) => {
        return item.title
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }
    if (option.searchType === "Artist") {
      clonedResults = clonedResults.filter((item: SongResult) => {
        return item.artist
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }
    if (option.searchType === "Requester") {
      clonedResults = clonedResults.filter((item: SongResult) => {
        return item.requester
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }
    if (option.searchType === "Date/Time") {
      clonedResults = clonedResults.filter((item: SongResult) => {
        return item.datetime
          .toLowerCase()
          .includes(option.searchText.toLowerCase())
      })
    }

    clonedResults.sort((a, b) => b.datetime.localeCompare(a.datetime))
    resultsWithSearch.value = clonedResults
  }
}

function deleteSearchRow(i: number) {
  searchOptions.value.splice(i, 1)
  updateSearch()
}

function generateCSV() {
  const refinedData: string[][] = []
  refinedData.push(["Title", "Artist", "Requester", "Date/Time(UTC)"])

  for (const song of resultsWithSearch.value) {
    try {
      refinedData.push([song.title, song.artist, song.requester, song.datetime])
    } catch (error) {
      console.log(error)
    }
  }

  let csvContent = "\ufeff"
  refinedData.forEach((row) => {
    csvContent += row.join(";") + "\n"
  })

  const date = new Date().toISOString().slice(0, 19)
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" })
  const objUrl = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = objUrl
  a.download = date.toString() + `_${channel.value}_songs_download` + ".csv"
  a.click()
  URL.revokeObjectURL(objUrl)
}

function getResultLength() {
  if (resultsWithSearch.value.length > 0) {
    return resultsWithSearch.value.length
  } else {
    return 0
  }
}

function resolveSongResults() {
  try {
    loadingText.value = "Formatting song results"
    for (let i = 0; i < playHistory.length; i++) {
      // Format each song
      undefinedCheck(playHistory[i])
    }

    if (playHistory.length > 0) {
      dataExists.value = true
    } else {
      dataExists.value = false
    }
  } catch (error) {
    console.log(error)
  }
  resultsWithSearch.value = results.value
}

function undefinedCheck(item: any) {
  let song: SongResult = {
    title: "-",
    artist: "-",
    requester: "-",
    datetime: "-",
  }

  if (item?.nonlistSong) {
    song.title = item.nonlistSong
  } else if (item?.song) {
    song.title = item.song?.title ? item.song.title : "-"
    song.artist = item.song?.artist ? item.song.artist : "-"
  }
  if (item?.requests[0]?.name) {
    song.requester = item.requests[0].name
  }
  if (item?.createdAt) {
    song.datetime = formatDate(item.createdAt)
  }

  results.value.push(song)
}

function formatDate(dateTime: string, firstSong?: boolean) {
  const date = new Date(dateTime)
  const year = date.getUTCFullYear()
  let month = String(date.getUTCMonth() + 1).padStart(2, "0")
  let day = String(date.getUTCDate()).padStart(2, "0")
  let hours = String(date.getUTCHours()).padStart(2, "0")
  let minutes = String(date.getUTCMinutes()).padStart(2, "0")

  if (firstSong) {
    return `${year}-${month}-${day}`
  } else {
    return `${year}-${month}-${day} Time: ${hours}:${minutes}`
  }
}

function handleRowClick(e, { item }) {
  let id = 0

  const filtered = allSongs.data.items.filter((song: any) => {
    return item.title === song.title && item.artist === song.artist
  })

  if (filtered.length > 0 && filtered !== undefined) {
    id = filtered[0].id
    window.open(
      `https://www.streamersonglist.com/t/${channel.value}/songs/${id}`,
      "_blank"
    )
  }
}

function addSearchOption() {
  searchOptions.value.push({
    searchType: "Title",
    searchText: "",
  })
}

async function loadStreamersFromDB() {
  try {
    storedStreamers.value = await songsDB.streamers.toArray()
  } catch (error) {
    console.log("Error: ", error)
  }
}

onMounted(() => {
  loadStreamersFromDB()
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pt-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(Card, {
                title: "Songlist tool",
                icon: "mdi-help-circle-outline",
                onIconClicked: openInfo
              }, {
                text: _withCtx(() => [
                  (isKermanix.value)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                width: "300",
                                src: require('../../assets/otamatone.jpg')
                              }, null, 8, ["src"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, { class: "align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        lg: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox, {
                            modelValue: userInput.channel,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInput.channel) = $event)),
                            label: textLabels.firstInput,
                            items: streamersFromStore.value,
                            variant: "outlined",
                            "hide-details": "",
                            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (loadSonglistHistory(false)), ["enter"]))
                          }, {
                            item: _withCtx(({ props, item }) => [
                              _createVNode(_component_v_list_item, _mergeProps(props, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (loadSonglistHistory(false)))
                              }), null, 16)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "label", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: _normalizeClass(_unref(mobile) ? 'px-0 pt-0 pb-4' : ''),
                        cols: "12",
                        lg: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            loading: loading.value,
                            disabled: loading.value,
                            color: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (loadSonglistHistory(false)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Search")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      (dataExists.value && !loading.value)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            lg: "6"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", null, [
                                  _hoisted_2,
                                  _createElementVNode("p", null, [
                                    _createTextVNode("Last update was "),
                                    _createElementVNode("strong", null, _toDisplayString(formatDate(songStoreLastUpdate.value)) + " (UTC)", 1)
                                  ]),
                                  (newSongsHasBeenPlayed.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_5))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_v_btn, {
                                  class: "mx-0",
                                  loading: loading.value,
                                  disabled: loading.value,
                                  color: "primary",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (loadSonglistHistory(true)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Update ")
                                  ]),
                                  _: 1
                                }, 8, ["loading", "disabled"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (loading.value)
                    ? (_openBlock(), _createBlock(Loader, {
                        key: 1,
                        text: loadingText.value
                      }, null, 8, ["text"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (dataExists.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_v_row, { class: "mt-4" }, {
                                default: _withCtx(() => [
                                  (totalPlayed.value && firstSong.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                        _createElementVNode("strong", null, _toDisplayString(channel.value), 1),
                                        _createTextVNode(" has played "),
                                        _createElementVNode("strong", null, _toDisplayString(totalPlayed.value), 1),
                                        _createTextVNode(" songs since "),
                                        _createElementVNode("strong", null, _toDisplayString(formatDate(firstSong.value, true)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_8, [
                                    _createTextVNode(" Results found: "),
                                    _createElementVNode("strong", null, _toDisplayString(getResultLength()), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_expansion_panels, { class: "py-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel, { title: "Search options" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_radio_group, {
                                            modelValue: radioGroup.selectedSearch,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((radioGroup.selectedSearch) = $event)),
                                            inline: !_unref(mobile),
                                            "hide-details": ""
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(radioGroup.searchStyles, (option, i) => {
                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                  key: `search-${i}`,
                                                  label: option.label,
                                                  value: option.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128)),
                                              _createVNode(_component_v_tooltip, null, {
                                                activator: _withCtx(({ props }) => [
                                                  _createElementVNode("div", _hoisted_9, [
                                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                                      class: _unref(mobile) ? 'ml-2' : 'ml-4'
                                                    }), {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString("mdi-help-circle-outline"))
                                                      ]),
                                                      _: 2
                                                    }, 1040, ["class"])
                                                  ])
                                                ]),
                                                default: _withCtx(() => [
                                                  _hoisted_10
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "inline"]),
                                          _createVNode(_component_v_divider, {
                                            class: _normalizeClass(_unref(mobile) ? 'mb-4' : '')
                                          }, null, 8, ["class"]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchOptions.value, (option, i) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                              _createElementVNode("div", _hoisted_11, [
                                                _createVNode(_component_v_select, {
                                                  modelValue: option.searchType,
                                                  "onUpdate:modelValue": ($event: any) => ((option.searchType) = $event),
                                                  label: "Search type",
                                                  items: [
                              'Title',
                              'Artist',
                              'Requester',
                              'Date/Time',
                            ],
                                                  variant: "outlined",
                                                  density: "compact",
                                                  "hide-details": "",
                                                  style: _normalizeStyle({ width: _unref(mobile) ? '100%' : '200px' })
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "style"]),
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: option.searchText,
                                                  "onUpdate:modelValue": ($event: any) => ((option.searchText) = $event),
                                                  label: textLabels.searchText,
                                                  density: "compact",
                                                  "hide-details": "",
                                                  style: _normalizeStyle({ width: _unref(mobile) ? '100%' : '' }),
                                                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (loadSonglistHistory(false)), ["enter"]))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "style"]),
                                                _createVNode(_component_v_btn, {
                                                  icon: "",
                                                  variant: "text",
                                                  color: "red",
                                                  disabled: searchOptions.value.length === 1,
                                                  onClick: ($event: any) => (deleteSearchRow(i))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString("mdi-delete"))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "onClick"])
                                              ]),
                                              _createVNode(_component_v_divider, { class: "pt-2" })
                                            ], 64))
                                          }), 128)),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_v_btn, {
                                              class: "px-0 mx-0",
                                              variant: "text",
                                              color: "primary",
                                              onClick: addSearchOption
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("+ Add new search option")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_v_btn, {
                                              class: "mx-0",
                                              loading: loading.value,
                                              disabled: loading.value,
                                              color: "primary",
                                              onClick: updateSearch
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Update")
                                              ]),
                                              _: 1
                                            }, 8, ["loading", "disabled"]),
                                            _createVNode(_component_v_btn, {
                                              class: "ml-2",
                                              loading: loading.value,
                                              disabled: loading.value,
                                              color: "red",
                                              onClick: resetSearch
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Reset")
                                              ]),
                                              _: 1
                                            }, 8, ["loading", "disabled"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    onClick: generateCSV
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Download csv")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (!loadingSearch.value)
                                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                                            key: 0,
                                            headers: headers,
                                            items: resultsWithSearchFallback.value,
                                            "fixed-header": "",
                                            height: "600px",
                                            "onClick:row": handleRowClick
                                          }, null, 8, ["items"]))
                                        : (_openBlock(), _createBlock(Loader, {
                                            key: 1,
                                            text: "Searching..."
                                          }))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(Dialog, {
        dialogOpen: openInfoDialog.value,
        "onUpdate:dialogOpen": _cache[7] || (_cache[7] = ($event: any) => ((openInfoDialog).value = $event)),
        title: "Info"
      }, {
        text: _withCtx(() => [
          _createVNode(_component_v_row, { class: "pt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(changelog).generalInfo), 1),
                  _createVNode(_component_v_divider, { class: "pt-2" }),
                  _hoisted_12,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(changelog).versions, (version, i) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(version.version), 1),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(version.changes), 1),
                      _createVNode(_component_v_divider, { class: "pt-2" })
                    ]))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["dialogOpen"])
    ]),
    _: 1
  }))
}
}

})